import LeadsActionTypes from "./leads.types";

/** ***************** ADD LEADS DETAILS START *********************** */
export const addLeadsDetailsStart = (addData: any) => ({
  type: LeadsActionTypes.ADD_LEADS_DETAILS_START,
  payload: addData,
});

export const addLeadsDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.ADD_LEADS_DETAILS_SUCCESS,
  payload: successData,
});

export const addLeadsDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.ADD_LEADS_DETAILS_FAILURE,
  payload: failureData,
});

export const addLeadsDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.ADD_LEADS_DETAILS_RESPONSE_RESET,
});

export const addLeadsDetailsResponseChanged = () => ({
  type: LeadsActionTypes.ADD_LEADS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD LEADS DETAILS END *********************** */

/** ***************** UPDATE LEADS DETAILS START *********************** */
export const updateLeadsDetailsStart = (updateData: any) => ({
  type: LeadsActionTypes.UPDATE_LEADS_DETAILS_START,
  payload: updateData,
});

export const updateLeadsDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.UPDATE_LEADS_DETAILS_SUCCESS,
  payload: successData,
});

export const updateLeadsDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.UPDATE_LEADS_DETAILS_FAILURE,
  payload: failureData,
});

export const updateLeadsDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.UPDATE_LEADS_DETAILS_RESPONSE_RESET,
});

export const updateLeadsDetailsResponseChanged = () => ({
  type: LeadsActionTypes.UPDATE_LEADS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE LEADS DETAILS END *********************** */

/** ***************** GET LEADS DETAILS START *********************** */
export const getLeadsListStart = (getData: any) => ({
  type: LeadsActionTypes.GET_LEADS_LIST_START,
  payload: getData,
});

export const getLeadsListSuccess = (successData: any) => ({
  type: LeadsActionTypes.GET_LEADS_LIST_SUCCESS,
  payload: successData,
});

export const getLeadsListFailure = (failureData: any) => ({
  type: LeadsActionTypes.GET_LEADS_LIST_FAILURE,
  payload: failureData,
});

export const getLeadsListResponseResetStart = () => ({
  type: LeadsActionTypes.GET_LEADS_LIST_RESPONSE_RESET,
});

export const getLeadsListResponseChanged = () => ({
  type: LeadsActionTypes.GET_LEADS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET LEADS DETAILS END *********************** */

/** ***************** FETCH LEADS DETAILS START *********************** */
export const fetchLeadsDetailsStart = (fetchData: any) => ({
  type: LeadsActionTypes.FETCH_LEADS_DETAILS_START,
  payload: fetchData,
});

export const fetchLeadsDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.FETCH_LEADS_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchLeadsDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.FETCH_LEADS_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchLeadsDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.FETCH_LEADS_DETAILS_RESPONSE_RESET,
});

export const fetchLeadsDetailsResponseChanged = () => ({
  type: LeadsActionTypes.FETCH_LEADS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH LEADS DETAILS END *********************** */

/** ***************** DELETE LEADS DETAILS START *********************** */
export const deleteLeadsDetailsStart = (deleteData: any) => ({
  type: LeadsActionTypes.DELETE_LEADS_DETAILS_START,
  payload: deleteData,
});

export const deleteLeadsDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.DELETE_LEADS_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteLeadsDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.DELETE_LEADS_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteLeadsDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.DELETE_LEADS_DETAILS_RESPONSE_RESET,
});

export const deleteLeadsDetailsResponseChanged = () => ({
  type: LeadsActionTypes.DELETE_LEADS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE LEADS DETAILS END *********************** */

/** ***************** STATUS LIST FOR DROP DOWN DETAILS START *********************** */
export const statusListDetailsStart = (ListData: any) => ({
  type: LeadsActionTypes.STATUS_LIST_DETAILS_START,
  payload: ListData,
});

export const statusListDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.STATUS_LIST_DETAILS_SUCCESS,
  payload: successData,
});

export const statusListDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.STATUS_LIST_DETAILS_FAILURE,
  payload: failureData,
});

export const statusListDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.STATUS_LIST_DETAILS_RESPONSE_RESET,
});

export const statusListDetailsResponseChanged = () => ({
  type: LeadsActionTypes.STATUS_LIST_DETAILS_RESPONSE_CHANGED,
});
/** *****************END  LIST FOR DROP DOWN DETAILS END *********************** */

/** ***************** GET PRODUCT LIST START *********************** */
export const getProductDropdownListStart = (getData: any) => ({
  type: LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_START,
  payload: getData,
});

export const getProductDropdownListSuccess = (successData: any) => ({
  type: LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_SUCCESS,
  payload: successData,
});

export const getProductDropdownListFailure = (failureData: any) => ({
  type: LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_FAILURE,
  payload: failureData,
});

export const getProductDropdownListResponseResetStart = () => ({
  type: LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_RESPONSE_RESET,
});

export const getProductDropdownListResponseChanged = () => ({
  type: LeadsActionTypes.GET_PRODUCT_DROPDOWN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET PRODUCT LIST END *********************** */

/** ***************** GET LEADSOURCE LIST START *********************** */
export const getleadsourceDropdownListStart = (getData: any) => ({
  type: LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_START,
  payload: getData,
});

export const getleadsourceDropdownListSuccess = (successData: any) => ({
  type: LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_SUCCESS,
  payload: successData,
});

export const getleadsourceDropdownListFailure = (failureData: any) => ({
  type: LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_FAILURE,
  payload: failureData,
});

export const getleadsourceDropdownListResponseResetStart = () => ({
  type: LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_RESPONSE_RESET,
});

export const getleadsourceDropdownListResponseChanged = () => ({
  type: LeadsActionTypes.GET_LEADSOURCE_DROPDOWN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET LEADSOURCE LIST END *********************** */

/** ***************** SEARCH PRELEAD LIMIT  START *********************** */
export const searchPreleadListStart = (getData: any) => ({
  type: LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_START,
  payload: getData,
});

export const searchPreleadListSuccess = (successData: any) => ({
  type: LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_SUCCESS,
  payload: successData,
});

export const searchPreleadListFailure = (failureData: any) => ({
  type: LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_FAILURE,
  payload: failureData,
});

export const searchPreleadListResponseResetStart = () => ({
  type: LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_RESPONSE_RESET,
});

export const searchPreleadListResponseChanged = () => ({
  type: LeadsActionTypes.SEARCH_PRELEAD_LIMIT_DETAILS_RESPONSE_CHANGED,
});
/** *****************SEARCH PRELEAD LIMIT  END *********************** */

/** ***************** FETCH LEADS  PRODUCT DETAILS START *********************** */
export const fetchDocumentDetailsStart = (fetchData: any) => ({
  type: LeadsActionTypes.FETCH_DOCUMENT_DETAILS_START,
  payload: fetchData,
});

export const fetchDocumentDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.FETCH_DOCUMENT_SUCCESS,
  payload: successData,
});

export const fetchDocumentDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.FETCH_DOCUMENT_FAILURE,
  payload: failureData,
});

export const fetchDocumentDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.FETCH_DOCUMENT_RESPONSE_RESET,
});

export const fetchDocumentDetailsResponseChanged = () => ({
  type: LeadsActionTypes.FETCH_DOCUMENT_RESPONSE_CHANGED,
});
/** ***************** FETCH LEADS  PRODUCT DETAILS END *********************** */

/** ***************** ADD DOCUMENT DETAILS START *********************** */
export const addDocumentDetailsStart = (addData: any) => ({
  type: LeadsActionTypes.CREATE_DOCUMENT_DETAILS_START,
  payload: addData,
});

export const addDocumentDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.CREATE_DOCUMENT_DETAILS_SUCCESS,
  payload: successData,
});

export const addDocumentDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.CREATE_DOCUMENT_DETAILS_FAILURE,
  payload: failureData,
});

export const addDocumentDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.CREATE_DOCUMENT_DETAILS_RESPONSE_RESET,
});

export const addDocumentDetailsResponseChanged = () => ({
  type: LeadsActionTypes.CREATE_DOCUMENT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD DOCUMENT DETAILS END *********************** */

/** ***************** ADD LOAN DETAILS START *********************** */
export const appliedLoanDetailsStart = (data: any) => ({
  type: LeadsActionTypes.LOAN_APPLIED_DETAILS_START,
  payload: data,
});

export const appliedLoanDetailsSuccess = (success: any) => ({
  type: LeadsActionTypes.LOAN_APPLIED_DETAILS_SUCCESS,
  payload: success,
});

export const appliedLoanDetailsFailure = (error: any) => ({
  type: LeadsActionTypes.LOAN_APPLIED_DETAILS_FAILURE,
  payload: error,
});

export const appliedLoanDetailsResetStart = () => ({
  type: LeadsActionTypes.LOAN_APPLIED_DETAILS_RESET,
});

export const appliedLoanDetailsChange = () => ({
  type: LeadsActionTypes.LOAN_APPLIED_DETAILS_CHANGE,
});

/** ***************** ADD LOAN DETAILS START *********************** */

/** ********************  LEAD APPLIED LOG  LIST FETCH START **************** */
export const leadAppliedLogListFetchStart = (leadAppliedLogList: any) => ({
  type: LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_START,
  payload: leadAppliedLogList,
});

export const leadAppliedLogListFetchSuccess = (success: any) => ({
  type: LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_SUCCESS,
  payload: success,
});

export const leadAppliedLogListFetchFailure = (failure: any) => ({
  type: LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_FAILURE,
  payload: failure,
});

export const leadAppliedLogListResponseResetStart = () => ({
  type: LeadsActionTypes.LEAD_APPLIED_LOG_LIST_RESPONSE_RESET_START,
});

export const leadAppliedLogListFetchResponseChanged = () => ({
  type: LeadsActionTypes.LEAD_APPLIED_LOG_LIST_FETCH_RESPONSE_CHANGED,
});

export const leadAppliedLogListClear = () => ({
  type: LeadsActionTypes.LEAD_APPLIED_LOG_LIST_CLEAR,
});
/** ******************** LEAD APPLIED LOG LIST FETCH END **************** */

/** ********************  SALE APPLIED LOG  LIST FETCH START **************** */
export const saleAppliedLogListFetchStart = (payload: any) => ({
  type: LeadsActionTypes.SALE_APPLIED_LOG_LIST_FETCH_START,
  payload,
});

export const saleAppliedLogListFetchSuccess = (success: any) => ({
  type: LeadsActionTypes.SALE_APPLIED_LOG_LIST_FETCH_SUCCESS,
  payload: success,
});

export const saleAppliedLogListFetchFailure = (failure: any) => ({
  type: LeadsActionTypes.SALE_APPLIED_LOG_LIST_FETCH_FAILURE,
  payload: failure,
});

export const saleAppliedLogListResponseResetStart = () => ({
  type: LeadsActionTypes.SALE_APPLIED_LOG_LIST_RESPONSE_RESET_START,
});

export const saleAppliedLogListFetchResponseChanged = () => ({
  type: LeadsActionTypes.SALE_APPLIED_LOG_LIST_FETCH_RESPONSE_CHANGED,
});
/** ******************** SALE APPLIED LOG LIST FETCH END **************** */

/** ***************** UPDATE LEADS  DOCUMENT DETAILS START *********************** */
export const updateLeadsDocDetailsStart = (updateData: any) => ({
  type: LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_START,
  payload: updateData,
});

export const updateLeadsDocDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_SUCCESS,
  payload: successData,
});

export const updateLeadsDocDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_FAILURE,
  payload: failureData,
});

export const updateLeadsDocDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_RESPONSE_RESET,
});

export const updateLeadsDocDetailsResponseChanged = () => ({
  type: LeadsActionTypes.UPDATE_LEADS_DOC_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE LEADS  DOCUMENT DETAILS END *********************** */

/** ***************** GET LEADS  DOCUMENT DETAILS START *********************** */
export const getLeadsDocListStart = (getData: any) => ({
  type: LeadsActionTypes.GET_LEADS_DOC_LIST_START,
  payload: getData,
});

export const getLeadsDocListSuccess = (successData: any) => ({
  type: LeadsActionTypes.GET_LEADS_DOC_LIST_SUCCESS,
  payload: successData,
});

export const getLeadsDocListFailure = (failureData: any) => ({
  type: LeadsActionTypes.GET_LEADS_DOC_LIST_FAILURE,
  payload: failureData,
});

export const getLeadsDocListResponseResetStart = () => ({
  type: LeadsActionTypes.GET_LEADS_DOC_LIST_RESPONSE_RESET,
});

export const getLeadsDocListResponseChanged = () => ({
  type: LeadsActionTypes.GET_LEADS_DOC_LIST_RESPONSE_CHANGED,
});
/** ***************** GET LEADS  DOCUMENT DETAILS END *********************** */

/** ***************** DELETE LEADS  DOCUMENT DETAILS START *********************** */
export const deleteLeadsDocDetailsStart = (deleteData: any) => ({
  type: LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_START,
  payload: deleteData,
});

export const deleteLeadsDocDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteLeadsDocDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteLeadsDocDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_RESPONSE_RESET,
});

export const deleteLeadsDocDetailsResponseChanged = () => ({
  type: LeadsActionTypes.DELETE_LEADS_DOC_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE LEADS  DOCUMENT DETAILS END *********************** */

// /** ***************** SEARCH COPMANY  LIST START *********************** */
export const getLeadAppliedListStart = (getData: any) => ({
  type: LeadsActionTypes.GET_LEAD_APPLIED_LIST_START,
  payload: getData,
});

export const getLeadAppliedListSuccess = (successData: any) => ({
  type: LeadsActionTypes.GET_LEAD_APPLIED_LIST_SUCCESS,
  payload: successData,
});

export const getLeadAppliedListFailure = (failureData: any) => ({
  type: LeadsActionTypes.GET_LEAD_APPLIED_LIST_FAILURE,
  payload: failureData,
});

export const getLeadAppliedListResponseResetStart = () => ({
  type: LeadsActionTypes.GET_LEAD_APPLIED_LIST_RESPONSE_RESET,
});

export const getLeadAppliedListResponseChanged = () => ({
  type: LeadsActionTypes.GET_LEAD_APPLIED_LIST_RESPONSE_CHANGED,
});

// /** *****************SEARCH COMPANY LIST END *********************** */

/** ***************** FETCH SIC DETAILS START *********************** */
export const fetchSicDetailsStart = (fetchData: any) => ({
  type: LeadsActionTypes.FETCH_SIC_DETAILS_START,
  payload: fetchData,
});

export const fetchSicDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.FETCH_SIC_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchSicDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.FETCH_SIC_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchSicDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.FETCH_SIC_DETAILS_RESPONSE_RESET,
});

export const fetchSicDetailsResponseChanged = () => ({
  type: LeadsActionTypes.FETCH_SIC_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH SIC DETAILS END *********************** */

/** ***************** ADD STATUS DETAILS START *********************** */
export const addStatusDetailsStart = (addData: any) => ({
  type: LeadsActionTypes.ADD_STATUS_DETAILS_START,
  payload: addData,
});

export const addStatusDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.ADD_STATUS_DETAILS_SUCCESS,
  payload: successData,
});

export const addStatusDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.ADD_STATUS_DETAILS_FAILURE,
  payload: failureData,
});

export const addStatusDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.ADD_STATUS_DETAILS_RESPONSE_RESET,
});

export const addStatusDetailsResponseChanged = () => ({
  type: LeadsActionTypes.ADD_STATUS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD STATUS DETAILS END *********************** */

/** ***************** UPDATE STATUS DETAILS START *********************** */
export const updateStatusDetailsStart = (updateData: any) => ({
  type: LeadsActionTypes.UPDATE_STATUS_DETAILS_START,
  payload: updateData,
});

export const updateStatusDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.UPDATE_STATUS_DETAILS_SUCCESS,
  payload: successData,
});

export const updateStatusDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.UPDATE_STATUS_DETAILS_FAILURE,
  payload: failureData,
});

export const updateStatusDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.UPDATE_STATUS_DETAILS_RESPONSE_RESET,
});

export const updateStatusDetailsResponseChanged = () => ({
  type: LeadsActionTypes.UPDATE_STATUS_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE STATUS DETAILS END *********************** */

/** ***************** DELETE LENDER APPLIED DETAILS START *********************** */
export const deleteLenderAppliedDetailsStart = (deleteData: any) => ({
  type: LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_START,
  payload: deleteData,
});

export const deleteLenderAppliedDetailsSuccess = (successData: any) => ({
  type: LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteLenderAppliedDetailsFailure = (failureData: any) => ({
  type: LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteLenderAppliedDetailsResponseResetStart = () => ({
  type: LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_RESPONSE_RESET,
});

export const deleteLenderAppliedDetailsResponseChanged = () => ({
  type: LeadsActionTypes.DELETE_LENDER_APPLIED_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE LENDER APPLIED DETAILS END *********************** */

/** ***************** SEARCH DASHBOARD LEADS START *********************** */
export const searchDashboardLeadsStart = (getData: any) => ({
  type: LeadsActionTypes.SEARCH_DASHBOARD_LEADS_START,
  payload: getData,
});

export const searchDashboardLeadsSuccess = (successData: any) => ({
  type: LeadsActionTypes.SEARCH_DASHBOARD_LEADS_SUCCESS,
  payload: successData,
});

export const searchDashboardLeadsFailure = (failureData: any) => ({
  type: LeadsActionTypes.SEARCH_DASHBOARD_LEADS_FAILURE,
  payload: failureData,
});

export const searchDashboardLeadsResponseResetStart = () => ({
  type: LeadsActionTypes.SEARCH_DASHBOARD_LEADS_RESPONSE_RESET,
});

export const searchDashboardLeadsResponseChanged = () => ({
  type: LeadsActionTypes.SEARCH_DASHBOARD_LEADS_RESPONSE_CHANGED,
});

export const deleteDashboardLeadsStart = (data: any) => ({
  type: LeadsActionTypes.DELETE_DASHBOARD_LEADS_START,
  payload: data,
});

export const deleteDashboardLeadsSuccess = (data: any) => ({
  type: LeadsActionTypes.DELETE_DASHBOARD_LEADS_SUCCESS,
  payload: data,
});

export const deleteDashboardLeadsFailure = (data: any) => ({
  type: LeadsActionTypes.DELETE_DASHBOARD_LEADS_FAILURE,
  payload: data,
});

export const deleteDashboardLeadsResponseResetStart = () => ({
  type: LeadsActionTypes.DELETE_DASHBOARD_LEADS_RESPONSE_RESET,
});

export const exportDashboardLeadsStart = (data: any) => ({
  type: LeadsActionTypes.EXPORT_DASHBOARD_LEADS_START,
  payload: data,
});

export const exportDashboardLeadsSuccess = (data: any) => ({
  type: LeadsActionTypes.EXPORT_DASHBOARD_LEADS_SUCCESS,
  payload: data,
});

export const exportDashboardLeadsFailure = (data: any) => ({
  type: LeadsActionTypes.EXPORT_DASHBOARD_LEADS_FAILURE,
  payload: data,
});

export const exportDashboardLeadsResponseResetStart = () => ({
  type: LeadsActionTypes.EXPORT_DASHBOARD_LEADS_RESPONSE_RESET,
});
/** ***************** SEARCH DASHBOARD LEADS END *********************** */
